import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/marketing/modelos-whatsapp',
)({
  component: () => <Outlet />,
})
